// @flow
/** @jsx h */
import { createContext, FunctionalComponent, h } from 'preact';
import { useContext, useReducer } from 'preact/hooks';

export type ErrorModalType = {
  isErrorModalOpen?: boolean,
  title?: string,
  errorCode?: number,
  message?: string,
  isRetryAllowed?: boolean,
  handleClose: Function,
  closeButtonText?: string,
  onRetryClick?: Function,
  retryButtonText?: string,
  hideCloseButton?: boolean,
  isRetryPrimary?: boolean,
  isClosePrimary?: boolean,
};

const initialModalState: ErrorModalType = {
  isErrorModalOpen: false,
  title: '',
  message: '',
  isRetryAllowed: false,
  handleClose: () => {},
};

type Action = { type: 'MODAL/OPEN' | 'MODAL/CLOSE', payload?: ErrorModalType };

type Dispatch = (action: Action) => void;

const reducer = (state: ErrorModalType, action: Action): ErrorModalType => {
  switch (action.type) {
    case 'MODAL/OPEN':
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        isErrorModalOpen: true,
      };
    case 'MODAL/CLOSE':
      return {
        ...initialModalState,
      };
    default:
      return state;
  }
};

const ErrorModalContext = createContext({});

const ErrorModalDispatchContext = createContext(() => {});

const ErrorModalStoreProvider: FunctionalComponent = ({
  template,
  children,
}) => {
  const [errorModalState, errorModalDispatch] = useReducer(
    reducer,
    initialModalState,
  );
  const value = { ...errorModalState, template };
  const dispatchValue = errorModalDispatch;

  return (
    <ErrorModalContext.Provider value={value}>
      <ErrorModalDispatchContext.Provider value={dispatchValue}>
        {children}
      </ErrorModalDispatchContext.Provider>
    </ErrorModalContext.Provider>
  );
};

const useErrorModalContext = () => {
  const context: ErrorModalType = useContext(ErrorModalContext);
  return context;
};

const useErrorModalContextDispatch = () => {
  const context: Dispatch = useContext(ErrorModalDispatchContext);
  return context;
};

export {
  ErrorModalStoreProvider,
  useErrorModalContext,
  useErrorModalContextDispatch,
  ErrorModalContext,
  ErrorModalDispatchContext,
};



// WEBPACK FOOTER //
// ./storeProviders/errorModalStore/index.js